import React, { useEffect } from "react"
import { withRouter } from "react-router-dom"
import { connect, useDispatch, useSelector } from "react-redux"

import {
    // card title
    Row,
    Col,
    Card,
    CardBody,
    Table
} from "reactstrap"
import PropTypes from "prop-types"
import * as crmDashboardAction from "../../store/session/actions"
import { isEmpty } from "lodash"
import moment from "moment"


const CrmDashBoard = () => {
    const dispatch = useDispatch()
    //initial loading api call
    useEffect(() => {
        dispatch(crmDashboardAction.loadCrmDashboard())
    }, [])

    //get data from list 
    const sessionUpdate = useSelector((specificstate) => specificstate.session)

    const { crmData = [], user = [] } = sessionUpdate
    const authUser = localStorage.getItem("authUser")

    const responseLogin = JSON.parse(authUser)
    //Date format
    const dateSetting =
        !isEmpty(responseLogin) &&
            responseLogin.setting &&
            responseLogin.setting.dateFormate
            ? responseLogin.setting.dateFormate.toUpperCase()
            : !isEmpty(user) && user.setting && user.setting.dateFormate
                ? user.setting.dateFormate.toUpperCase()
                : []

    const dateFormat = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  

    const clientData = crmData && !isEmpty(crmData) ? crmData.overAllClientDetails : {}

    const clientDetails = [
        { title: "Total Pending Leads Count", count: clientData.totalPendingLeadsCount || 0 },
        { title: "Unique Client Count", count: clientData.uniqueClientCount || 0 },
        { title: "Total Dormant Leads", count: clientData.totalDormantLeads || 0 },
        { title: "Total Dormant Unique Clients", count: clientData.totalDormantClients || 0 },
        { title: "Total Completed Leads", count: clientData.totalCompletedLeads || 0 },
        { title: "Total Reviews Till Date", count: clientData.reviewTillDateCount || 0 },
    ]

    const countSplitValue = crmData && !isEmpty(crmData) ? crmData.clientTypeSplit : ""

    const clientTypeSplit = [
        { title: "Escalated Clients", count: countSplitValue.escalatedClients },
        { title: "Only Engagement Client", count: countSplitValue.onlyEngagementClients },
        { title: "Orange Clients", count: countSplitValue.orangeClients },
        { title: "Green Clients", count: countSplitValue.greenClients },
        { title: "Blue Clients", count: countSplitValue.blueClients },
    ]
    const deliverableData = crmData && !isEmpty(crmData) ? crmData.deliverableCountWiseSplit : {}

    const deliverableCount = [
        { title: "0 Deliverable Pending", count: deliverableData.zero_deliverables || 0 },
        { title: "1 Deliverable Pending", count: deliverableData.deliverable_one || 0 },
        { title: "2 Deliverable Pending", count: deliverableData.deliverable_second || 0 },
        { title: "3 Deliverable Pending", count: deliverableData.deliverable_three || 0 },
        { title: ">3 Deliverable Pending", count: deliverableData.deliverable_greaterthenthree || 0 },
    ]

    const followupData = crmData && !isEmpty(crmData) ? crmData.followupReport || {} : {}

    const followupReport = [
        { title: "Today's Followup Count", count: followupData.noOfTodayFollowups || 0 },
        { title: "Yesterday's Followup Count", count: followupData.noOfYesterdayFollowups || 0 },
        { title: "Average Followup Per Day (Last 7 Days)", count: followupData.avg_7_Days || 0 },
        { title: "Average Followup Per Day (Last 30 Days)", count: followupData.avg_30_Days || 0 },
        { title: "Average Followup Per Day (Last 60 Days)", count: followupData.avg_60_Days || 0 },
        { title: "Lead Count Without Followup", count: followupData.leadWithoutFollowup || 0 },
        { title: "Total Future Followup Count", count: followupData.totalFutureFollowup || 0 },
        { title: "Total No Of Aging Followup", count: followupData.totalAgingFollowup || 0 },
        { title: "Highest Aging", count: followupData.highestAging || 0 },
        { title: "On Time Followup Completion % (Last 30 Days)", count: followupData.onTime_30_days || 0 },
    ]


    const cardStyles = [
        { backgroundColor: "#0D70E2", color: "#fff" }, // Client Details
        { backgroundColor: "#f1b54c", color: "#fff" }, // Client Type Split
        { backgroundColor: "#34c28f", color: "#fff" }, // Deliverable Count
    ]


    const rowStyle = {
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid #ddd",
        padding: "5px 0",
        fontSize: "14px",
    }
    const firstColumnCount = crmData && crmData.deliFollowupReason ? crmData.deliFollowupReason : {}

    const firstColumnData = [
        { name: "Album Selection", count: firstColumnCount["ALB SEL"] || 0 },
        { name: "Frame Selection", count: firstColumnCount["FRM SEL"] || 0 },
        { name: "Retouch Selection", count: firstColumnCount["RT SEL"] || 0 },
        { name: "CV Song Selection", count: firstColumnCount["CV SNG CNF"] || 0 },
        { name: "Montage Song Confirmation", count: firstColumnCount["MNT SNG CNF"] || 0 },
        { name: "Album Print", count: firstColumnCount["ALB PRNT"] || 0 },
        { name: "Magazine Print Confirmation", count: firstColumnCount["MAG PRNT"] || 0 },
        { name: "Frame Print Confirmation", count: firstColumnCount["FRM PRNT"] || 0 },
        { name: "Address Followup", count: firstColumnCount["ADRS FUP"] || 0 },
        { name: "Data Changes", count: firstColumnCount["DT CHRGS"] || 0 },
        { name: "Product Upselling", count: firstColumnCount["PRD UPSL"] || 0 },
        { name: "Product Feedback", count: firstColumnCount["PRD FDBK"] || 0 },
        { name: "Dormant Closure", count: firstColumnCount["DRMT CLSR"] || 0 },
        { name: "Client Referral", count: firstColumnCount["CLNT RFRL"] || 0 }
    ]

   

    const secondColumnCount = crmData && crmData.deliverableStatusWiseCount
        || {}

    const secondColumnData = [
        { name: "Total Albums - Client Pending", count: secondColumnCount["album_CP"] || 0 },
        { name: "Total Frames - Client Pending", count: secondColumnCount["frames_CP"] || 0 },
        { name: "Total Retouch - Client Pending", count: secondColumnCount["retouch_CP"] || 0 },
        { name: "Total CV - Client Pending", count: secondColumnCount["CV_CP"] || 0 },
        { name: "Total Montage - Client Pending", count: secondColumnCount["montage_CP"] || 0 },
        { name: "Total Albums - Print Confirmation Pending", count: secondColumnCount["albums_PCP"] || 0 },
        { name: "Total Magazine - Print Confirmation Pending", count: secondColumnCount["magazine_PCP"] || 0 },
        { name: "Total Frame - Print Confirmation Pending", count: secondColumnCount["frame_PCP"] || 0 },
        { name: "Total Dispatch Pending", count: secondColumnCount["dispatchPending"] || 0 },
        { name: "Overall Data Changes", count: secondColumnCount["overAllDataChanges"] || 0 },
        { name: "Overall Product Upselling", count: secondColumnCount["overAllProductUpselling"] || 0 },
        { name: "Overall Product Feedback", count: secondColumnCount["overAllProductFeedBack"] || 0 },
        { name: "Total Pending Leads > 180 Days", count: secondColumnCount["pendingLeads"] || 0 },
        { name: "Overall Client Referral", count: secondColumnCount["overAllClientReferral"] || 0 }
    ]

  


    const topThreeTableData = crmData && crmData.top3_Aging_Followups && !isEmpty(crmData.top3_Aging_Followups) ?
        crmData.top3_Aging_Followups.map((top, index) => {
            return {
                sNo: index + 1,
                leadNumber: top.leadNo || "--",
                brideName: top.brideName || "--",
                groomName: top.groomName || "--",
                futureFollowupDate: top.futureFollowupDate ? moment(top.futureFollowupDate).format(dateFormat) : "--",
                futureFollowupRemarks: top.futureFollowupRemarks || "--",
                previousFollowupDate: top.previousFollowupDate ?
                    moment(top.previousFollowupDate).format(dateFormat) : "--",
                agingDate: top.agingDays || "--"
            }
        }) : []

    const data = crmData && crmData.escalatedClientsList
  

    return (
        <React.Fragment>
            <div style={{ padding: "20px" }}>
                {/* Row 1 - Summary Cards */}
                <Row>
                    {[clientDetails, clientTypeSplit, deliverableCount].map(
                        (category, idx) => (
                            <Col md={4} key={idx}>
                                <Card style={{ backgroundColor: cardStyles[idx].backgroundColor, color: cardStyles[idx].color, padding: "15px", marginBottom: "20px", boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)" }}>
                                    <CardBody>
                                        <h5 style={{ fontWeight: "bold", marginBottom: "10px", color: cardStyles[idx].color }}>
                                            {idx === 0
                                                ? "Overall Client Details"
                                                : idx === 1
                                                    ? "Client Type Split"
                                                    : "Deliverable Count-wise Split"}
                                        </h5>
                                        {category.map((item, index) => (
                                            <p key={index} style={rowStyle}>
                                                <span>{item.title}</span>
                                                <span>{item.count}</span>
                                            </p>
                                        ))}
                                    </CardBody>
                                </Card>
                            </Col>
                        )
                    )}
                </Row>

                {/* Row 2 - Followup Report + Two Data Tables */}
                <Row>
                    <Col md={4}>
                        <Card
                            style={{
                                backgroundColor: "#f46969",
                                height: "700px",
                                color: "#fff",
                                padding: "15px",
                                marginBottom: "20px",
                                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            }}
                        >
                            <CardBody style={{ maxHeight: "600px", overflowY: "auto" }}>
                                <h5 style={{ fontWeight: "bold", marginBottom: "10px", color: "#fff" }}>
                                    Followup Report
                                </h5>
                                {followupReport.map((item, index) => (
                                    <p key={index} style={rowStyle}>
                                        <span>{item.title}</span>
                                        <span>{item.count}</span>
                                    </p>
                                ))}
                            </CardBody>
                        </Card>
                    </Col>
                    <Col md={8}>
                        {/* <Card style={{ padding: "15px", height: "330px", marginBottom: "20px", boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)" }}>
                            <CardBody>
                                <h5 style={{ fontWeight: "bold", marginBottom: "10px" }}>
                                    Top 3 Aging Followup List
                                </h5>
                                <div
                                    style={{
                                        maxHeight: "250px",
                                        paddingRight: "10px", // Adding padding to prevent overlap with scroll
                                    }}
                                >
                                    <Col md="12" lg="12" xl="12" className="mt-3">
                                        <PaginationProvider
                                            pagination={paginationFactory(options)}
                                            keyField="_id"
                                            columns={columns}
                                        >
                                            {({ paginationProps, paginationTableProps }) => (
                                                <ToolkitProvider
                                                    keyField="_id"
                                                    data={topThreeTableData}
                                                    columns={columns}
                                                    search
                                                    exportCSV
                                                >
                                                    {(props) => (
                                                        <div>
                                                            <Col md="12" xl="12" lg="12" sm="12" xs="12">
                                                                <Row className="d-flex flex-row  ">

                                                                    <Col>
                                                                        <BootstrapTable
                                                                            {...props.baseProps}
                                                                            responsive
                                                                            striped={true}
                                                                            bordered={true}
                                                                            keyField="_id"
                                                                            columns={columns}
                                                                            noDataIndication={"No Data Found..."}
                                                                            {...paginationTableProps}
                                                                        />
                                                                    </Col>
                                                                </Row>
                                                                <Row
                                                                    style={{ marginTop: "5px" }}
                                                                    className="align-items-md-center mt-30"
                                                                >
                                                                    <Col className="inner-custom-pagination d-flex">
                                                                        <div className="d-inline d-flex flex-row">
                                                                            <SizePerPageDropdownStandalone
                                                                                {...paginationProps}
                                                                            />
                                                                            <div
                                                                                style={{
                                                                                    fontSize: "14px",
                                                                                    marginTop: "8px",
                                                                                    marginLeft: "4px",
                                                                                }}
                                                                            >
                                                                                <PaginationTotalStandalone
                                                                                    {...paginationProps}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            className="text-md-right ms-auto"
                                                                            style={{ zIndex: 0 }}
                                                                        >
                                                                            <PaginationListStandalone
                                                                                {...paginationProps}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </Col>
                                                        </div>
                                                    )}
                                                </ToolkitProvider>
                                            )}
                                        </PaginationProvider>
                                    </Col>
                                </div>
                            </CardBody>
                        </Card> */}
                        <Card
                            style={{
                                padding: "15px",
                                height: "330px",
                                marginBottom: "20px",
                                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                overflow: "hidden", // Prevent content from overflowing
                            }}
                        >
                            <CardBody>
                                <h5 style={{ fontWeight: "bold", marginBottom: "10px" }}>
                                    Top 3 Aging Followup List
                                </h5>
                                <div style={{ maxHeight: '250px', overflowY: 'auto', paddingRight: '10px' }}>
                                    <Table striped bordered responsive>
                                        <thead>
                                            <tr>
                                                <th style={{ minWidth: '60px' }}>S.No</th>
                                                <th style={{ minWidth: '120px' }}>Lead NO</th>
                                                <th style={{ minWidth: '140px' }}>Bride Name</th>
                                                <th style={{ minWidth: '140px' }}>Groom Name</th>
                                                <th style={{ minWidth: '170px' }}>Future Followup Date</th>
                                                <th style={{ minWidth: '200px' }}>Future Followup Remarks</th>
                                                <th style={{ minWidth: '200px' }}>Previous Followup Date</th>
                                                <th style={{ minWidth: '140px' }}>Aging Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {topThreeTableData.length > 0 ? (
                                                topThreeTableData.map((row, index) => (
                                                    <tr key={index}>
                                                        <td>{row.sNo}</td>
                                                        <td>{row.leadNumber}</td>
                                                        <td>{row.brideName}</td>
                                                        <td>{row.groomName}</td>
                                                        <td>{row.futureFollowupDate}</td>
                                                        <td>{row.futureFollowupRemarks}</td>
                                                        <td>{row.previousFollowupDate}</td>
                                                        <td>{row.agingDate}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan='8' className='text-center'>No Data Found...</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>

                                </div>
                            </CardBody>
                        </Card>
                        <Card
                            style={{
                                padding: "15px",
                                height: "330px",
                                marginBottom: "20px",
                                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                                overflow: "hidden", // Prevent content from overflowing
                            }}
                        >
                            <CardBody>
                                <h5 style={{ fontWeight: "bold", marginBottom: "10px" }}>
                                    Escalation Client List

                                </h5>
                                <div style={{ maxHeight: '250px', overflowY: 'auto', paddingRight: '10px' }}>

                                    <Table bordered responsive>
                                        <thead>
                                            <tr>
                                                <th style={{ minWidth: "60px" }}>S.No</th>
                                                <th style={{ minWidth: "120px" }}>Lead No</th>
                                                <th style={{ minWidth: "140px" }}>Bride Name</th>
                                                <th style={{ minWidth: "140px" }}>Groom Name</th>
                                                <th style={{ minWidth: "130px" }}>Event Date</th>
                                                <th style={{ minWidth: "150px" }}>Event Name</th>
                                                <th style={{ minWidth: "200px" }}>Total Deliverable Count</th>
                                                <th style={{ minWidth: "220px" }}>Pending Deliverable Count</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data ? (
                                                data.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.leadNo || "--"}</td>
                                                        <td>{item.brideName || "--"}</td>
                                                        <td>{item.groomName || "--"}</td>
                                                        <td>
                                                            {item.eventDate.length > 0
                                                                ? item.eventDate
                                                                    .map(date => moment(date).format(dateFormat))
                                                                    .join(" | ")
                                                                : "--"}
                                                        </td>
                                                        <td>{item.eventName.length > 0 ? item.eventName.join(", ") : "--"}</td>
                                                        <td>{item.totalDeliverableCount }</td>
                                                        <td>{item.pendingDeliverableCount }</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">
                                                        No Data Found...
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                {/* Row 3 - Comparison Data Table */}
                {/* <Row>
                <Col md={12}>
                  <Card style={{ padding: "15px", boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)" }}>
                    <CardBody>
                      <h5 style={{ fontWeight: "bold", marginBottom: "10px" }}>
                        Comparison Data Table
                      </h5>
                      <Table bordered>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Column 1</th>
                            <th>Column 2</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>1</td>
                            <td>Data</td>
                            <td>Data</td>
                          </tr>
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                </Col>
              </Row> */}

                <Row>
                    <Col md={12}>
                        <Card style={{ padding: "15px", boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)" }}>
                            <CardBody>
                                <h5 style={{ fontWeight: "bold", marginBottom: "10px" }}>Last 7 Days- Followup Type Today - 1</h5>
                                <div style={{ overflowX: "auto" }}>
                                    <Table bordered>
                                        <thead>
                                            <tr>
                                                {/* Common Headers */}
                                                <th colSpan={2} style={{ backgroundColor: "#F8D7DA", textAlign: "center", fontWeight: "bold", fontSize: "16px", padding: "10px", }}>
                                                    Followup Type
                                                </th>
                                                <th colSpan={2} style={{ backgroundColor: "#D1ECF1", textAlign: "center", fontWeight: "bold", fontSize: "16px", padding: "10px", }}>
                                                    Deliverable Status Wise
                                                </th>
                                            </tr>

                                            <tr>
                                                <th style={{ backgroundColor: "#F8D7DA", width: "25%" }}> </th>
                                                <th style={{ backgroundColor: "#F8D7DA", width: "10%" }}>Count</th>
                                                <th style={{ backgroundColor: "#D1ECF1", width: "10%" }}>Count</th>
                                                <th style={{ backgroundColor: "#D1ECF1", width: "25%" }}></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {firstColumnData.map((item, index) => (
                                                <tr key={index}>
                                                    {/* First column */}
                                                    <td style={{ backgroundColor: "#F8D7DA" }}>{item.name}</td>
                                                    <td style={{ backgroundColor: "#F8D7DA", textAlign: "center" }}>
                                                        {item.count}
                                                    </td>
                                                    {/* Second column */}
                                                    <td style={{ backgroundColor: "#D1ECF1", textAlign: "center" }}>
                                                        {secondColumnData[index].count || 0} {/* Accessing count from secondColumnData */}
                                                    </td>
                                                    <td style={{ backgroundColor: "#D1ECF1" }}>
                                                        {secondColumnData[index].name} {/* Accessing name from secondColumnData */}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
        </React.Fragment>
    )
}


CrmDashBoard.propTypes = {
    dispatch: PropTypes.func,
    record_quotation_details: PropTypes.array,
    loading: PropTypes.any,
    success: PropTypes.any,
    searchProps: PropTypes.func,
    baseProps: PropTypes.any,
    csvProps: PropTypes.any,
    searchBarStyle: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    }
}


const mapStateToProps = () => ({
    //mapstate to prop
})
//CrmDashBoard
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CrmDashBoard)
)


